import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router-dom';

import { DataBlocks, I18n, MyBeelineBanner } from 'components';

import ReportPeriod from '../ReportPeriod';
import ReportPopup from '../ReportPopup';
import Balances from '../Balances';
import Expenses from '../Expenses';
import Payments from '../Payments';
import LastExpenses from '../LastExpenses';
import HomeInternet from '../HomeInternet';

const PrepaidDetalization = ({ match, isConvergent, isPorted }) => {
  const indexUrl = `${match.path}`;
  const paymentsUrl = `${match.path}/last-payments`;
  const lastExpensesUrl = `${match.path}/last-expenses`;

  return (
    <Switch>
      <Route
        path={indexUrl}
        exact
        render={() => (
          <DataBlocks.Container>
            {!isPorted && (
              <MyBeelineBanner
                text="Детализация — это просто. Просто установите мобильное приложение «Мой билайн»!"
                images={{
                  iOS: '//static.beeline.ru/upload/images/mlk/images/mpBanner/ios-detalization.png',
                  Android: '//static.beeline.ru/upload/images/mlk/images/mpBanner/android-detalization.png',
                }}
              />
            )}

            <DataBlocks.Block
              title={<I18n path="detalization.blockTitle" />}
            >
              <ReportPeriod />
              <Balances />
              <Expenses />
            </DataBlocks.Block>
            {!isPorted && (
              <Payments />
            )}
            {isConvergent && (
              <HomeInternet />
            )}
            <ReportPopup />
          </DataBlocks.Container>
        )}
      />
      <Route
        path={paymentsUrl}
        exact
        render={() => (
          <DataBlocks.Container>
            <Payments />
          </DataBlocks.Container>
        )}
      />
      <Route
        path={lastExpensesUrl}
        exact
        render={() => (
          <DataBlocks.Container>
            <LastExpenses />
          </DataBlocks.Container>
        )}
      />
      <Redirect to={indexUrl} />
    </Switch>
  );
};

PrepaidDetalization.propTypes = {
  match: PropTypes.object,
  isPorted: PropTypes.bool,
  isConvergent: PropTypes.bool,
};

export default PrepaidDetalization;
